import { useQuery } from '@tanstack/react-query';
import { getOrganizationLanguages } from '../services/requests';

export const useOrganizationLanguages = () => {
  return useQuery({
    queryKey: ['organizationLanguages'],
    queryFn: () => getOrganizationLanguages(),
  });
};
